var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0498 1.55005H1.77203C1.44787 1.55005 1.137 1.67882 0.907785 1.90803C0.678574 2.13724 0.549805 2.44812 0.549805 2.77227V11.3278C0.549805 11.652 0.678574 11.9629 0.907785 12.1921C1.137 12.4213 1.44787 12.55 1.77203 12.55H10.3276C10.6517 12.55 10.9626 12.4213 11.1918 12.1921C11.421 11.9629 11.5498 11.652 11.5498 11.3278V7.05005",
    stroke: "#484848",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4983 0.902039C10.7236 0.676663 11.0293 0.550049 11.348 0.550049C11.6668 0.550049 11.9724 0.676663 12.1978 0.902039C12.4232 1.12741 12.5498 1.43309 12.5498 1.75182C12.5498 2.07055 12.4232 2.37622 12.1978 2.6016L6.81588 7.98353L4.5498 8.55005L5.11632 6.28397L10.4983 0.902039Z",
    stroke: "#484848",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.a6a6c9bd2ed8b5b82097f3af220d5f0a.svg";
export { ForwardRef as ReactComponent };